var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"Financial"},[_c('router-view',{on:{"openModalOperation":_vm.handleOpenModalOperation}}),_c('DialogOperation',{ref:"DialogOperation"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }